import React from 'react';

export default function StatCard({ icon, value, label, color }) {
  return (
    <div className="stat-card">
      <div className={`icon-box ${color}`}><i className={icon} /></div>
      <div className="stat-info">
        <h3>{value}</h3>
        <p>{label}</p>
      </div>
    </div>
  );
}
